import {formatMonth} from "@/lib/dateTimeUtilities"

export default class Costs {
  quoteDollarsPrice = 0
  quoteDollarsCost = 0
  invoicedDollars = 0
  invoicedPercent = 0
  currentDollarsPrice = 0
  currentDollarsCost = 0
  currentToDateDollars = 0
  currentPercent = 0
  toInvoicePercent = 0
  toInvoiceDollars = 0
  toInvoiceDollarsCost = 0
  newInvoicedTotal = 0
  newInvoicedPercent = 0
  latestInvoiceDate = 0 // timestamp
  summary = []

  costDescriptions = []

  job = undefined

  constructor(vue, invoicePeriod, startDate, endDate) {
    this.vue = vue
    this.invoicePeriod = invoicePeriod
    this.startDate = startDate
    this.endDate = endDate
  }
  round(number, decimals) {
    if (typeof number !== "number") return 0
    const factor = Math.pow(10, decimals)
    return Math.round(number * factor) / factor
  }

  recalculateCosts(what) {
    const value = this.round(100 * this.invoicedDollars / this.quoteDollarsPrice,1)
    this.invoicedPercent = Number.isFinite(value) ? value : "--"

    this.currentToDateDollars = this.currentDollarsPrice + this.invoicedDollars
    const value2 = this.round(100 * this.currentToDateDollars / this.quoteDollarsPrice,1)
    this.currentPercent = Number.isFinite(value) ? value2 : "--"

    if (what === "percent") {
      const amount = this.round((100 * (this.toInvoiceDollars + this.invoicedDollars)) / this.quoteDollarsPrice,1)
      this.toInvoicePercent = Number.isFinite(amount) ? amount : 100
    } else if (what === "amount") {
      this.toInvoiceDollars = ((this.toInvoicePercent / 100) * this.quoteDollarsPrice) - this.invoicedDollars
      this.toInvoiceDollars = Math.max(0, this.round(this.toInvoiceDollars,2))
    }
    this.newInvoicedTotal = this.toInvoiceDollars + this.invoicedDollars

    const value3 = this.round(100 * this.newInvoicedTotal / this.quoteDollarsPrice,1)
    this.newInvoicedPercent = Number.isFinite(value3) ? value3 : "--"
  }

  processWfmJob(job) {
    this.job = job
  }

  processWfmCosts(response) {
    let thisMonthAccruedCostsPrice = 0
    let thisMonthAccruedCostsCost = 0

    const _this = this
    const endOfMonth = (new Date(this.endDate + "T23:59")).getTime()
    const startOfMonth = (new Date(this.startDate + "T00:00")).getTime()

    if (response.Costs) {
      const costs = this.vue.$ensureArray(response.Costs.Cost)
      costs.forEach(function (cost) {
        const costTime = (new Date(cost.Date)).getTime()
        if (costTime > endOfMonth) return // skip as the cost is in the future

        const date = formatMonth(cost.Date)
        const priceDollars = parseFloat(cost.UnitPrice) * parseFloat(cost.Quantity)
        const costDollars = parseFloat(cost.UnitCost) * parseFloat(cost.Quantity)

        if (costTime >= startOfMonth) {
          thisMonthAccruedCostsPrice += priceDollars
          thisMonthAccruedCostsCost += costDollars
          let note = cost.Note ? cost.Note : ""
          if (_this.job.DateCreatedUtc.substr(0, 11) === cost.Date.substr(0, 11)) { // note which costs are probably estimates
            note += " DELETE ME"
          }
          note = _this.cleanText(note)
          _this.summary.push(`${date} ${note} (${_this.vue.$formatCurrency(priceDollars)})`)
          _this.costDescriptions.push(note)

        }
      })
    }

    this.currentDollarsPrice = thisMonthAccruedCostsPrice
    this.currentDollarsCost = thisMonthAccruedCostsCost
    this.toInvoiceDollars = thisMonthAccruedCostsPrice
    this.toInvoiceDollarsCost = thisMonthAccruedCostsCost
  }

  processWfmQuote(response) {
    const quote = response.Quote

    let quotePriceAmount = 0
    let quoteCostAmount = 0
    if (quote && quote.Costs) {
      const quoteCosts = this.vue.$ensureArray(quote.Costs.Cost)
      quoteCosts.forEach(function (quoteCost) {
        quotePriceAmount += parseFloat(quoteCost.Amount)
        quoteCostAmount += parseFloat(quoteCost.UnitCost) * parseFloat(quoteCost.Quantity)
      })
    }
    this.quoteDollarsPrice = quotePriceAmount
    this.quoteDollarsCost = quoteCostAmount
  }

  processWfmInvoice(response) {
    const _this = this
    let invoices = []

    if (response.Invoices) {
      invoices = _this.vue.$ensureArray(response.Invoices.Invoice)
    }

    let invoicedCostsAmount = 0
    invoices.forEach(function (invoice) {
      // skip if not paid or approved
      if (!["Paid", "Approved"].includes(invoice.Status)) return
      
      const endOfMonth = (new Date(_this.endDate + "T00:00")).getTime()
      const invoiceDate = (new Date(invoice.Date)).getTime()
      if (invoiceDate >= endOfMonth) return // skip - future time

      _this.latestInvoiceDate = Math.max(invoiceDate, _this.latestInvoiceDate)
      if (invoice.Jobs.Job.Costs) {
        const invoicedCosts = _this.vue.$ensureArray(invoice.Jobs.Job.Costs.Cost)
        invoicedCosts.forEach(function (invoicedCost) {
          if (invoicedCost.Billable === "Yes") {
            invoicedCostsAmount += parseFloat(invoicedCost.Amount)
          }
        })
      }
    })
    _this.invoicedDollars = invoicedCostsAmount
  }

  processBwf(response) {
    this.comments = response.comments
    if (response.costs.percentage) {
      this.toInvoicePercent = response.costs.percentage
    }
    if (response.costs.amount) {
      this.toInvoiceDollars = this.round(response.costs.amount, 2)
    }
  }

  cleanText(str) {
    if (str) {
      const A = str.replace(/([^.])$/, "$1.")
      return A.charAt(0).toUpperCase() + A.slice(1)
    } else {
      return ""
    }
  }

  copyActuals() {
    this.toInvoiceDollars = this.currentDollarsPrice
    this.recalculateCosts("percent")
  }

}